export enum TransferTimeStatus {
  Instant = 'instant',
  Timed = 'timed',
  TimedExecuted = 'timedExecuted',
}
